export default __webpack_public_path__ + "static/media/customerIcon.64dee922.svg";